var _defineProperty = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var breathe = require('../utils/breathe'); //Change some terms to more human readable


var translations = {
  precision: 'GPS Accuracy',
  fix: 'GPS Fix'
}; //Returns the GPS data as a string

function getGPGS5Data(_x) {
  return _getGPGS5Data.apply(this, arguments);
} //Converts the processed data to KML


function _getGPGS5Data() {
  _getGPGS5Data = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var frameRate, device, inner, key, stream, name, units, sticky, i, s, partialSticky, cmt, time, altitudeMode, _key, coords, partial, description;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            inner = '';
            if (data['frames/second'] != null) frameRate = "".concat(Math.round(data['frames/second']), " fps");
            _context2.t0 = _regeneratorRuntime.keys(data);

          case 3:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 25;
              break;
            }

            key = _context2.t1.value;
            if (data[key]['device name'] != null) device = data[key]['device name'];

            if (!data[key].streams) {
              _context2.next = 23;
              break;
            }

            _context2.t2 = _regeneratorRuntime.keys(data[key].streams);

          case 8:
            if ((_context2.t3 = _context2.t2()).done) {
              _context2.next = 23;
              break;
            }

            stream = _context2.t3.value;
            _context2.next = 12;
            return breathe();

          case 12:
            if (!(stream === 'GPS5' && data[key].streams.GPS5.samples)) {
              _context2.next = 21;
              break;
            }

            name = void 0;
            if (data[key].streams.GPS5.name != null) name = data[key].streams.GPS5.name;
            units = void 0;
            if (data[key].streams.GPS5.units != null) units = data[key].streams.GPS5.units.toString();
            sticky = {}; //Loop all the samples

            for (i = 0; i < data[key].streams.GPS5.samples.length; i++) {
              s = data[key].streams.GPS5.samples[i]; //Check that at least we have the valid values

              if (s.value && s.value.length > 1) {
                //Update and remember sticky data
                if (s.sticky) sticky = _objectSpread(_objectSpread({}, sticky), s.sticky);
                partialSticky = [];
                cmt = '';
                time = '';
                altitudeMode = ''; //Create comments for sample

                for (_key in sticky) {
                  partialSticky.push("".concat(translations[_key] || _key, ": ").concat(sticky[_key]));
                }

                if (s.value.length > 3) partialSticky.push("2D Speed: ".concat(s.value[3]));
                if (s.value.length > 4) partialSticky.push("3D Speed: ".concat(s.value[4])); //Create comment string

                if (partialSticky.length) cmt = "\n            <description>".concat(partialSticky.join('; '), "</description>"); //Set time if present

                if (s.date != null) {
                  if (typeof s.date != 'object') s.date = new Date(s.date);

                  try {
                    time = "\n            <TimeStamp>\n                <when>".concat(s.date.toISOString(), "</when>\n            </TimeStamp>");
                  } catch (e) {
                    time = "\n            <TimeStamp>\n                <when>".concat(s.date, "</when>\n            </TimeStamp>");
                  }
                } //Prepare coordinates


                coords = [s.value[1], s.value[0]]; //Set elevation if present

                if (s.value.length > 2) {
                  coords.push(s.value[2]);
                  altitudeMode = "\n            <altitudeMode>absolute</altitudeMode>";
                } //Create sample string


                partial = "\n        <Placemark>\n            ".concat(cmt.trim(), "\n            <Point>\n                ").concat(altitudeMode.trim(), "\n                <coordinates>").concat(coords.join(','), "</coordinates>\n            </Point>\n            ").concat(time.trim(), "\n        </Placemark>"); //Add it to samples

                inner += "".concat(partial);
              }
            } //Create description of file/stream


            description = [device, frameRate, name, units].filter(function (e) {
              return e != null;
            }).join('. ');
            return _context2.abrupt("return", {
              inner: inner,
              description: description
            });

          case 21:
            _context2.next = 8;
            break;

          case 23:
            _context2.next = 3;
            break;

          case 25:
            return _context2.abrupt("return", {
              inner: inner,
              description: [device, frameRate].filter(function (e) {
                return e != null;
              }).join('. ')
            });

          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getGPGS5Data.apply(this, arguments);
}

module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
    var name, converted, string;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            name = _ref.name;
            _context.next = 3;
            return getGPGS5Data(data);

          case 3:
            converted = _context.sent;
            string = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<kml xmlns=\"http://www.opengis.net/kml/2.2\" xmlns:atom=\"http://www.w3.org/2005/Atom\">\n    <Document>\n        <name>".concat(name, "</name>\n        <atom:author>\n            <atom:name>gopro-telemetry by Juan Irache</atom:name>\n        </atom:author>\n        <atom:link href=\"https://github.com/JuanIrache/gopro-telemetry\"/>\n        <description>").concat(converted.description, "</description>\n        ").concat(converted.inner.trim(), "\n    </Document>\n</kml>");
            return _context.abrupt("return", string);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();